export const TicketTypeFilter = Object.freeze({
    STANDARD: 'standard',
    CAT1: 'cat1',
    CAT2: 'cat2',
});
